import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface IconGridProps {
  columns: number;
  rows?: number;
}

export default styled.div<IconGridProps>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, min-content);
  grid-template-rows: repeat(3, 1fr);
  gap: 7px;

  @media screen and (min-width: ${DESKTOP}px) {
    gap: 9px;
  }
`;
